export default "__VITE_ASSET__205e111c__"